import { Component, NgZone, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { MenuItem, MenuItemPath, MenuItemRoute } from '@enums/menu-item.enum';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'app/core/services/account.service';
import { NotificationService } from 'app/core/services/notification.service';

@Component({
  selector: 'app-error-counter',
  templateUrl: './error-counter.component.html',
  styleUrls: ['./error-counter.component.scss']
})
export class ErrorCounterComponent implements OnInit {

  counterTonnageError = 0;
  counterTollError = 0;
  errorLabel = '';

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger


  constructor(
    public translateService: TranslateService,
    private notificationService: NotificationService,
    private accountService: AccountService,
    private router: Router,
    private zone: NgZone
  ) { }

  ngOnInit() {
    this.accountService.getNotificationCount().subscribe(value => {
      this.counterTonnageError = value[0];
      this.counterTollError = value[1];
      if (this.counterTonnageError > 0 || this.counterTollError > 0) {
        this.setLabel();
      }
    });
    this.notificationService.counterNotification.subscribe(value => {
      this.counterTonnageError = value[0];
      this.counterTollError = value[1];
      if (this.counterTonnageError > 0 || this.counterTollError > 0) {
        this.setLabel();
      }
    });
  }
  setLabel() {
    this.translateService
      .get('error-counter.error',
        {counter : (this.counterTonnageError + this.counterTollError).toString()})
      .subscribe(text => {
        this.errorLabel = text;

      });
  }

  onErrorClick(event: any) {
    if (this.counterTonnageError != 0 || this.counterTollError != 0) {
      if (this.counterTonnageError == 0) {
        this.trigger.closeMenu();
        this.goToTollError();
      } else if (this.counterTollError == 0) {
        this.trigger.closeMenu();
        this.goToTonnageError();
      } else {
        event.preventDefault();
      }
    } else {
      this.trigger.closeMenu();
      event.preventDefault();
    }
  }

  goToTonnageError() {
    const currentUrl = this.router.url;
    this.zone.run(() => this.router.navigate([MenuItemPath.get(MenuItem.statements)], {
      queryParams: {
        selectedTab: "0",
        isError: "true",
        start: "null",
        end: "null"
      }
    }));
  }
  goToTollError() {
    const currentUrl = this.router.url;
    this.zone.run(() => this.router.navigate([MenuItemPath.get(MenuItem.statements)], {
      queryParams: {
        selectedTab: "1",
        isError: "true",
        start: "null",
        end: "null"
      }
    }));
  }
}
